import Item from "../../components/Item";

const ItemPage = () => {
  return (
    <div>
      <Item />
    </div>
  );
};

export default ItemPage;
